import React, { ReactNode, forwardRef, useImperativeHandle } from 'react';
import * as S from './Accordion.styles';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';

type AccordionProps = {
  title: ReactNode;
  subTitle?: ReactNode;
  contentHead?: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
  maxHeight?: number;
  className?: string;
};

export interface AccordionRef {
  close: () => void;
}

export const Accordion = forwardRef<AccordionRef, AccordionProps>(
  (
    {
      title,
      subTitle,
      children,
      contentHead,
      defaultOpen = false,
      maxHeight,
      className,
    },
    ref
  ) => {
    const [isOpen, toggle] = useToggleOpenState(defaultOpen);

    useImperativeHandle(ref, () => ({ close: () => toggle(false) }), []);

    return (
      <S.Wrapper className={className}>
        <S.Header onClick={toggle}>
          <S.Title>
            {title}
            <S.Arrow $isOpen={isOpen} />
          </S.Title>
          {subTitle && <S.SubTitle>{subTitle}</S.SubTitle>}
        </S.Header>

        {isOpen && contentHead}
        <S.Content $isOpen={isOpen} $maxHeight={maxHeight}>
          <S.ContentBox $hasTopPadding={!contentHead}>{children}</S.ContentBox>
        </S.Content>
      </S.Wrapper>
    );
  }
);

Accordion.displayName = 'Accordion';
